// extracted by mini-css-extract-plugin
export default {"mainDiv":"LoginAdmin_mainDiv__aKbuU","loginButton":"LoginAdmin_loginButton__cF1b6"};